import { fieldDescription, FormField } from '@codecorp/zorm-conventions'
import React from 'react'
import { z } from 'zod'
import { useShowModal } from '../hooks/use-show-modal'
import { lockUnlockBarcode, Pin } from '@codecorp/barcode-data-generator'
import { useZorm } from 'react-zorm'
import { ShowBarcode } from '../components/show-barcode'
import { useFormReset } from '../hooks/use-form'
import { CreatorButtons } from '../components/creator-buttons'
const FormSchema = z
    .object({
        label: z.string().describe(
            fieldDescription({
                placeHolder: 'This name will be placed under the QR Code.',
            })
        ),

        shouldLock: z
            .enum(['lock', 'unlock'])
            .transform((x) => (x === 'lock' ? true : false))
            .describe(
                fieldDescription({
                    labels: ['Lock', 'Unlock'],
                    label: 'Lock',
                })
            ),

        pin: z
            .string()
            .regex(/^$|^\d{4,8}$/)
            .optional()
            .transform((x) => (x !== '' ? x : null))
            .describe(
                fieldDescription({
                    label: 'PIN',
                    tooltip: 'Please enter a PIN between 4 to 8 digits.',
                    placeHolder: 'Enter PIN',
                })
            ),
    })
    .refine(
        (data) => data.shouldLock == null || data.pin != null,
        'PIN must be given if lock is enabled'
    )
export const LockUnlockBarcode = () => {
    const { setSubmittedBarcode, handleFormReset } = useFormReset(undefined)
    const showModal = useShowModal()

    const zo = useZorm('lockUnlockBarcode', FormSchema, {
        onValidSubmit: async ({ preventDefault, data }) => {
            preventDefault()

            setSubmittedBarcode(data)
            showModal(
                <ShowBarcode
                    label={data.label ?? ''}
                    barcode={lockUnlockBarcode({
                        ...data,
                        // doing this in the transformer breaks zo.fields.pin typing somehow
                        pin: data.pin as Pin,
                        shouldLock: data.shouldLock,
                    })}
                />
            )
        },
    })
    return (
        <div>
            <form
                ref={zo.ref}
                className="ml-10 mr-10 leading-10"
                onReset={handleFormReset}
            >
                {zo.fields.label(FormField)}
                {zo.fields.shouldLock(FormField)}
                {zo.fields.pin(FormField)}

                <p className="text-pink-600">{zo.errors()?.message}</p>
                <CreatorButtons />
            </form>
        </div>
    )
}
